<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout row wrap align-center style="margin-top:0px;">
            <v-card style="margin-left:400px">
              <v-btn class="primary" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px" v-on:click="sho1()">In-Bound Dispatch</v-btn>
              <v-btn  flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px;color: #ffffff" v-on:click="sho2() && activate(1)" :class="{ active_el : active_el == 1 }">Out-Bound Dispatch</v-btn>
            </v-card>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs12>
          <v-flex xs2></v-flex>
          <v-flex xs8>
            <v-card style="margin-top:20px">
              <v-card-text>
                <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Out-Bound Dispatch</h3>
                </v-layout>
                <v-divider divider: true style="margin-bottom: 50px"></v-divider>
                <v-flex style="margin-left:20px">
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Dispatch Type</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:10px">
                      <v-overflow-btn
                        :items="dispatchtype"
                        label="Please Mention"
                        target="#dropdown-example"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Vehicle No</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:10px">
                      <v-overflow-btn
                        :items="vehicleno"
                        label="Please Mention"
                        target="#dropdown-example"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                      <v-flex xs4 style="margin-top:20px">
                        <label>City</label>
                      </v-flex>
                      <v-flex xs6 style="margin-top:10px">
                        <v-overflow-btn
                          :items="city"
                          label="Select"
                          target="#dropdown-example"
                          outline
                        ></v-overflow-btn>
                      </v-flex>
                    </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Dispatch Date</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        :return-value.sync="date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        style="margin-left:20px"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="date"
                        label="Select Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                      </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:30px">
                      <label>Dispatch Time</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:20px">
                      <v-text-field
                        v-model="dispatchtime"
                        label=""
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:30px">
                      <label>Current Status</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:20px">
                      <v-text-field
                        v-model="status"
                        label=""
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <h3 style="text-align:left;margin-bottom: 10px;margin-left:20px;margin-top: 20px">Shipment Details</h3>
                  </v-layout>
                  <v-layout row wrap>
                      <v-flex xs3 style="margin-top:20px;margin-left:20px">
                        <label>Docket No</label>
                        <v-overflow-btn
                          :items="docketno"
                          label="Select"
                          target="#dropdown-example"
                          outline
                          style="margin-top:20px"
                        ></v-overflow-btn>
                      </v-flex>
                      <v-flex xs2 style="margin-top:20px;margin-left:20px">
                        <label>City</label>
                        <v-text-field
                          v-model="city"
                          label="Select"
                          target="#dropdown-example"
                          outline
                          style="margin-top:20px"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs3 style="margin-top:20px;margin-left:20px">
                        <label>Commodity</label>
                        <v-overflow-btn
                          :items="commodity"
                          label="Select"
                          target="#dropdown-example"
                          outline
                          style="margin-top:20px"
                        ></v-overflow-btn>
                      </v-flex>
                      <v-flex xs2 style="margin-top:20px;margin-left:20px">
                        <label>Status</label>
                        <v-overflow-btn
                          :items="status"
                          label="Select"
                          target="#dropdown-example"
                          outline
                          style="margin-top:20px"
                        ></v-overflow-btn>
                      </v-flex>
                  </v-layout>
                  <v-btn flat style="margin-left:-650px;" v-on:click="addnew()">+ Add New</v-btn>
                </v-flex>
                <v-btn class="primary" style="margin-left:20px;" v-on:click="submit()">Submit</v-btn>
                <v-btn class="default" style="margin-left:20px;">Reset</v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs2></v-flex>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      dispatchtype: ['Full Truck Load', 'Part Load'],
      outchallanno: [],
      vehicleno: [],
      menu: false,
      date: new Date().toISOString().substr(0, 10),
      dispatchtime: '',
      docketno: [],
      status1: [],
      commodity: '',
      status: [],
      city: []
    }
  },
  methods: {
    submit () {
    },
    sho1 () {
      this.$router.push('/Transportationinbounddispatch')
    },
    sho2 () {
      this.$router.push('/Transportationoutbounddispatch')
    },
    activate: function (el) {
      this.active_el = el
    }
  }
}
</script>

<style>
  .active_el {
    background-color: #00C853
  }
</style>



// WEBPACK FOOTER //
// src/components/Transportationoutbounddispatch.vue